export function getPapers() {
  return this.get(`/bookmarked`, {py: true})
  }

export function bookmarkPaper(uuid) {
  return this.post(`/bookmark?source_id=${uuid}`, null, {py: true})
}
